import { OnInit, EventEmitter } from '@angular/core';
import { SavedSearch } from '../../../classes/saved-search';
import { SavedSearchLocationType } from '../../../classes/enums';
var SavedSearchesComponent = /** @class */ (function () {
    function SavedSearchesComponent() {
        this.SavedSearchLocationType = SavedSearchLocationType;
        this._savedSearches = [];
        this.onStartSearchClick = new EventEmitter();
        this.onDeleteAllClick = new EventEmitter();
        this.onDeleteSavedSearchClick = new EventEmitter();
        this.onSaveChangesClick = new EventEmitter();
        this.onSavedSearchClick = new EventEmitter();
        this.SavedSearch = SavedSearch;
    }
    Object.defineProperty(SavedSearchesComponent.prototype, "savedSearches", {
        get: function () {
            return this._savedSearches;
        },
        set: function (value) {
            this._savedSearches = value;
        },
        enumerable: true,
        configurable: true
    });
    SavedSearchesComponent.prototype.ngOnInit = function () { };
    SavedSearchesComponent.prototype.saveChangesClicked = function () {
        this.onSaveChangesClick.emit(this.savedSearches);
    };
    return SavedSearchesComponent;
}());
export { SavedSearchesComponent };
